// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3NJ7O"};